export const largeSourceImage = (sourceImageURL) => {
    return sourceImageURL.replace('/srcimg%2F', '/srcimg_large%2F')
}